import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { useParams } from 'react-router-dom';
import { DEVICE_MODEL_CACHE_KEY } from 'services/queryKeys';
import { DeviceModel } from 'types';

export function DeviceModelBreadcrumb() {
  const { deviceModelId = '' } = useParams();

  const { data: deviceModel = {} as DeviceModel } = useAxiosQuery<DeviceModel>(
    DEVICE_MODEL_CACHE_KEY(deviceModelId),
    `/device-models/${deviceModelId}/`,
    { enabled: !!deviceModelId }
  );

  return deviceModel?.externalIdentifier ?? deviceModelId;
}
